import { createSlice } from '@reduxjs/toolkit';
import initialState from './employeeInitialState';
import { _setEmployee } from './employeeAction';

export const employeeSlice = createSlice({
  name: 'delta/employee',
  initialState,
  reducers: {
    setEmployee: _setEmployee,
    resetEmployee: () => initialState,
  },
});

export const { getSharedFolderForm, setEmployee, resetEmployee } =
  employeeSlice.actions;

export default employeeSlice.reducer;
